<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <global-footer class="footer custom-render">
    <template v-slot:links>
      <div class="footer-line">
        <a
          v-show="showLogo === 'true'"
          href="https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=%E6%B9%96%E5%8D%97%E5%90%88%E6%B1%87%E7%A7%91%E6%8A%80&fenlei=256&rsv_pq=0xd8b93c3d0005c696&rsv_t=9487uHnUtRtjq44yD7fsy0Oc0epIYC5O9pkF%2Fnwg4VX7ybEaA2AXMBK4v27A&rqlang=en&rsv_dl=tb&rsv_enter=1&rsv_sug3=20&rsv_sug1=16&rsv_sug7=101&rsv_sug2=0&rsv_btype=i&prefixsug=%25E6%25B9%2596%25E5%258D%2597%25E5%2590%2588%25E6%25B1%2587%25E7%25A7%2591%25E6%258A%2580&rsp=5&inputT=6783&rsv_sug4=7473"
          target="_blank"
          class="company-link"
        >
          湖南合汇科技有限公司
        </a>
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link"> 湘ICP备2021013700号-1 </a>

        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43100202000366"
          class="police-beian-link"
        >
          <img src="/iconImg/batb.png" alt="备案图标" class="beian-icon" />
          <span class="beian-text">湘公网安备 43100202000366号</span>
        </a>
      </div>
    </template>
    <template v-slot:copyright>
      <span></span>
    </template>
  </global-footer>
</template>

<script>
import { GlobalFooter } from '@ant-design-vue/pro-layout'

export default {
  name: 'ProGlobalFooter',
  components: {
    GlobalFooter,
  },
  data() {
    return {
      showLogo: process.env.VUE_APP_LOGO,
      isPipelineMappingPage: false
    }
  },
  mounted() {
    // 检查当前路由是否为PipelineMapping页面
    this.checkCurrentRoute();
    // 添加路由变化监听
    this.$router.afterEach(() => {
      this.checkCurrentRoute();
    });
    // 立即再次检查，确保状态正确
    this.$nextTick(() => {
      this.checkCurrentRoute();
      console.log('当前路径:', this.$route.path);
      console.log('是否为PipelineMapping页面:', this.isPipelineMappingPage);
    });
  },
  methods: {
    checkCurrentRoute() {
      const currentPath = this.$route.path;
      this.isPipelineMappingPage = currentPath === '/gather-mapping/pipeline-mapping';
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  &.custom-render {
    padding: 0;
    text-align: center;
    background: transparent;
    margin-top: 0;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 8px;
    
    // 在PipelineMapping页面中隐藏页脚
    display: v-bind('isPipelineMappingPage ? "none !important" : "block !important"');
    
    :deep(.ant-pro-global-footer) {
      margin: 0;
      padding: 0;
      min-height: 24px;
      background: transparent;
    } 

    :deep(.ant-pro-global-footer-links) {
      margin: 0;
      padding: 0 0 2px;
      text-align: center;
    }

    :deep(.ant-pro-global-footer-copyright) {
      margin: 0;
      padding: 0 0 2px;
      text-align: center;
      display: none;
    }
  }

  .company-link {
    color: #939393;
    transition: color 0.3s;
    font-size: 12px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    display: inline-block;

    &:hover {
      color: #1890ff;
    }
  }

  .footer-line {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    white-space: nowrap;
    flex-wrap: wrap;
    background: transparent;
    margin: 0 auto;
  }

  .beian-link {
    color: #939393;
    transition: color 0.3s;
    font-size: 12px;
    margin: 0;
    padding: 0;

    &:hover {
      color: #1890ff;
    }
  }

  .police-beian-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #939393;
    transition: color 0.3s;
    font-size: 12px;
    margin: 0;
    padding: 0;

    &:hover {
      color: #1890ff;
    }
  }

  .beian-icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .beian-text {
    line-height: 12px;
  }
}
</style>

<style lang="less">
/* 覆盖 antd Layout.Footer 默认内边距 */
.ant-layout-footer {
  padding-top: 0 !important;
}
</style>
